import React from 'react';
import { Unknown } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const UnknownError = () => {
    const { t } = useTranslation();
    const history = useHistory();

    return <Unknown tFunc={t} onLinkClick={() => history.push('/')} />;
};

export default UnknownError;
